import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMarkdown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 20,
	viewBox: "0 -960 960 960",
	width: 20,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m600-384 96-96-34-34-38 38v-100h-48v100l-38-39-34 35 96 96ZM168-192q-29.7 0-50.85-21.162Q96-234.324 96-264.04v-432.243Q96-726 117.15-747T168-768h624q29.7 0 50.85 21.162Q864-725.676 864-695.96v432.243Q864-234 842.85-213T792-192H168Zm0-72h624v-432H168v432Zm0 0v-432 432Zm72-120h48v-144h24v96h48v-96h24v144h48v-168q0-10.2-6.9-17.1-6.9-6.9-17.1-6.9H264q-10.2 0-17.1 6.9-6.9 6.9-6.9 17.1v168Z" })
});
export default SvgMarkdown;
